import { Button } from "@shopify/polaris";
import { GettingStartedStoreAccess } from "../../../libs/store";

interface MarkStepAsCompleteButtonProps {
  isDisabled: boolean;
}

export function MarkStepAsCompleteButton({ isDisabled }: MarkStepAsCompleteButtonProps) {
  const { update } = GettingStartedStoreAccess.useActions();

  const clickHandler = () => {
    update(
      [
        {
          path: "onSiteSetup.smartrrWidget.completed",
          val: true,
        },
      ],
      "subscriptionBlock"
    );
  };

  return (
    <div data-testid="app-block-mark-as-complete-button">
      <Button disabled={isDisabled} onClick={clickHandler}>
        Mark step as complete
      </Button>
    </div>
  );
}
